/* Join-only visual preview. No quiz state, subscription, storage or analytics access. */
(() => {
  'use strict';
  document.querySelectorAll('[data-join-sommelier]').forEach(root => {
    if (root.dataset.demoReady) return;
    root.dataset.demoReady = 'true';
    const choices = Array.from(root.querySelectorAll('[data-demo-select]'));
    const phones = Array.from(root.querySelectorAll('[data-demo-phone]'));
    const rail = root.querySelector('.join-sommelier-phones');
    const questions = Array.from(root.querySelectorAll('[data-demo-question-panel]'));
    const play = root.querySelector('[data-demo-play]');
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let step = 0;
    let paused = motion.matches;
    let autoAdvance = true;
    let question = 0;
    let visible = false;
    let hovered = false;
    let focused = false;
    let timer = null;
    let questionTimer = null;
    let scrollTimer = null;

    const select = (index, scroll = true) => {
      step = index;
      root.dataset.demoStep = String(index);
      choices.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
      phones.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
      if (scroll && rail && typeof rail.scrollTo === 'function') {
        rail.scrollTo({ left: phones[index].offsetLeft - (rail.clientWidth - phones[index].offsetWidth) / 2, behavior: motion.matches ? 'instant' : 'smooth' });
      }
    };
    const sync = () => {
      window.clearTimeout(timer);
      window.clearTimeout(questionTimer);
      timer = null;
      questionTimer = null;
      root.dataset.demoQuestion = String(question);
      questions.forEach((panel, i) => { panel.hidden = i !== question; });
      const animating = !paused && visible && !document.hidden;
      root.dataset.demoAnimating = String(animating);
      play.hidden = false;
      play.setAttribute('aria-pressed', String(paused));
      play.textContent = paused ? play.dataset.playLabel : play.dataset.pauseLabel;
      if (animating && autoAdvance && !hovered && !focused) {
        timer = window.setTimeout(() => { question = 0; select((step + 1) % choices.length); sync(); }, step === 0 ? 9000 : 6500);
      }
      if (animating && step === 0 && questions.length > 1) {
        questionTimer = window.setTimeout(function nextQuestion() {
          question = (question + 1) % questions.length;
          root.dataset.demoQuestion = String(question);
          questions.forEach((panel, i) => { panel.hidden = i !== question; });
          questionTimer = window.setTimeout(nextQuestion, 2300);
        }, 2300);
      }
    };
    choices.concat(phones).forEach(button => button.addEventListener('click', () => {
      const index = Number(button.dataset.demoSelect ?? button.dataset.demoPhone);
      question = step === index && index === 0 ? (question + 1) % questions.length : 0;
      select(index);
      // Manual selection keeps this screen active while its own illustration animates.
      autoAdvance = false;
      sync();
    }));
    if (rail) rail.addEventListener('scroll', () => {
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(() => {
        if (rail.scrollWidth <= rail.clientWidth) return;
        const bounds = rail.getBoundingClientRect();
        const centre = bounds.left + bounds.width / 2;
        let index = step;
        let distance = Infinity;
        phones.forEach((phone, i) => {
          const box = phone.getBoundingClientRect();
          const nextDistance = Math.abs(box.left + box.width / 2 - centre);
          if (nextDistance < distance) { index = i; distance = nextDistance; }
        });
        if (index === step) return;
        question = 0;
        // Follow the settled swipe without scrolling the rail back or restarting autoplay.
        select(index, false);
        autoAdvance = false;
        sync();
      }, 120);
    }, { passive: true });
    play.addEventListener('click', () => { paused = !paused; if (!paused) autoAdvance = true; sync(); });
    root.addEventListener('pointerenter', event => { hovered = event.pointerType !== 'touch'; sync(); });
    root.addEventListener('pointerleave', () => { hovered = false; sync(); });
    root.addEventListener('focusin', event => { focused = event.target !== play; sync(); });
    root.addEventListener('focusout', event => {
      if (!root.contains(event.relatedTarget)) { focused = false; sync(); }
    });
    document.addEventListener('visibilitychange', sync);
    motion.addEventListener('change', () => { if (motion.matches) paused = true; sync(); });
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        visible = entries.some(entry => entry.isIntersecting);
        sync();
      }, { threshold: 0.15 });
      observer.observe(root);
    } else {
      visible = true;
    }
    select(0);
    sync();
  });
})();
